/**
 * Google Tag Manager Configuration
 * Store your GTM container ID here
 */

export const GTM_CONFIG = {
  // Replace with your actual GTM container ID (format: GTM-XXXXXXX)
  gtmId: import.meta.env.VITE_GTM_ID || '',

  // Optional: custom data layer name (default is 'dataLayer')
  dataLayerName: 'dataLayer',

  // Enable GTM only if both conditions are met:
  // 1. GTM ID is provided
  // 2. VITE_GTM_ENABLED is explicitly set to 'true'
  enabled:
    import.meta.env.VITE_GTM_ENABLED === 'true' &&
    !!import.meta.env.VITE_GTM_ID,
};
